export const PASSWORD_POLICY_MESSAGE =
  "Password must be at least 10 characters and include uppercase, lowercase, number, and special character.";

export function validatePasswordPolicy(password, label = "Password") {
  const value = String(password || "");

  if (!value.trim()) {
    return `${label} is required.`;
  }

  if (value.length < 10) {
    return PASSWORD_POLICY_MESSAGE;
  }

  if (/\s/.test(value)) {
    return `${label} must not contain spaces.`;
  }

  const hasUpper = /[A-Z]/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasDigit = /\d/.test(value);
  const hasSpecial = /[^A-Za-z0-9]/.test(value);

  return hasUpper && hasLower && hasDigit && hasSpecial
    ? ""
    : PASSWORD_POLICY_MESSAGE;
}
